import React, { MouseEvent, useRef } from "react";
import {
    Chart as ChartJS,
    LinearScale,
    CategoryScale,
    BarElement,
    PointElement,
    LineElement,
    registerables,
    Legend,
    Tooltip,
    InteractionItem,
} from 'chart.js';
import { Chart, getElementAtEvent } from 'react-chartjs-2';
import ChartDataLabels from "chartjs-plugin-datalabels";
import { utilFunctions } from "../../../../_helpers";

ChartJS.register(
    LinearScale,
    CategoryScale,
    BarElement,
    PointElement,
    LineElement,
    Legend,
    ChartDataLabels,
    Tooltip,
    ...registerables
);

export const options = {
    responsive: true,
    maintainAspectRatio: false,
    chart: {
        redrawOnParentResize: true,
        redrawOnWindowResize: true,
        toolbar: {
            show: true,
            tools: {
                download: true,
                selection: false,
                zoom: false,
                zoomin: false,
                zoomout: false,
                pan: false,
                reset: false,
            }
        }

    },
    plugins: {
        title: {
            display: true,
            text: '',
        },
        legend: {
            display: false,
            font: {
                weight: 'normal'
            },
        },
        datalabels: {
            display: true,
            color: "white",

            formatter: function (value, context) {
                if (context.dataset.type === 'bar') {
                    if (value > 0) {
                        return value;
                    } else {
                        value = "";
                        return value;
                    }
                } else {
                    value = "";
                    return value;
                }

            }
        }
    },
    scales: {
        x: {
            stacked: true,
            ticks: {
                // maxRotation: 0,
                // minRotation: 0,
                autoSkip: false,
                // font: {
                //     size: 8,
                // }
            }
        },
        y: {
            stacked: true,
            title: {
                display: true,
                text: 'Time',
                color: '#000000'
            }
        },
    },
};

const YamazumiGroupedStackedChart = (props) => {

    const INITIAL: any = {
        labels: [],
        datasets: []
    }
    const [stackedChartData, setStackedChartData] = React.useState(INITIAL);
    const [stackedChartOptions, setStackedCharOptions] = React.useState(options);
    const chartRef = useRef<ChartJS>(null);

    React.useEffect(() => {
        let categories = []
        let datasets = []
        let tactTime = []
        let pitchTime = []
        !!props.categories ? categories = props.categories : categories = [];
        !!props.datasets ? datasets = props.datasets : datasets = [];
        if (!!props.datasets) {
            for (let i = 0; i < props.categories.length; i++) {
                tactTime.push(props.tactTime)
                pitchTime.push(props.pitchTime)
            }
        }

        setStackedCharOptions({
            responsive: true,
            maintainAspectRatio: false,
            chart: {
                redrawOnParentResize: true,
                redrawOnWindowResize: true,
                toolbar: {
                    show: true,
                    tools: {
                        download: true,
                        selection: false,
                        zoom: false,
                        zoomin: false,
                        zoomout: false,
                        pan: false,
                        reset: false,
                    }
                }

            },
            plugins: {
                title: {
                    display: true,
                    text: '',
                },
                legend: {
                    display: props.legend,
                    font: {
                        weight: 'normal'
                    },
                },
                datalabels: {
                    display: true,
                    color: "white",

                    formatter: function (value, context) {
                        if (context.dataset.type === 'bar') {
                            if (value > 0) {
                                return utilFunctions.formatCycleTimes(value);
                            } else {
                                value = "";
                                return value;
                            }
                        } else {
                            value = "";
                            return value;
                        }

                    },
                }
            },
            scales: {
                x: {
                    stacked: true,
                    ticks: {
                        // maxRotation: 90,
                        // minRotation: 90,
                        autoSkip: false,
                        // font: {
                        //     size: 12,
                        // }
                    }
                },
                y: {
                    stacked: true,
                    title: {
                        display: true,
                        text: 'Time',
                        color: '#000000'
                    }
                }
            },
        })

        setStackedChartData({
            labels: categories,
            datasets: [
                {
                    type: 'line' as const,
                    label: 'Tact Time',
                    borderColor: 'rgb(255, 0, 0)',
                    borderWidth: 1,
                    fill: false,
                    data: tactTime,
                    stack: "line2",
                    chartDataLabels: false
                },
                {
                    type: 'line' as const,
                    label: 'Pitch Time',
                    borderColor: 'rgb(0, 0, 255)',
                    borderWidth: 1,
                    fill: false,
                    data: pitchTime,
                    stack: "line"
                },
                ...datasets.map(dataset => {
                    return {
                        ...dataset,
                        data: dataset.data.map(val => utilFunctions.formatCycleTimes(val))
                    }
                })
            ]
        })

    }, [props])

    const onDataSelection = (event: MouseEvent<HTMLCanvasElement>) => {
        const { current: chart } = chartRef;
        if (!chart) {
            return;
        }

        const element: InteractionItem[] = getElementAtEvent(chart, event)
        if (!element.length) return;

        const { datasetIndex, index } = element[0];
        props.onStackBarSelect(stackedChartData.labels[index])
    }
    return (
        <React.Fragment>
            <Chart
                type='bar'
                options={stackedChartOptions}
                data={stackedChartData}
                height={props.height}
                ref={chartRef}
                onClick={onDataSelection}
            />
        </React.Fragment>
    )
}

export default YamazumiGroupedStackedChart